/* eslint-disable react/no-unknown-property */
import React from 'react'

import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import useInquiryCount from '../../../hooks/inquiry/use-inquiry-count'

interface KPIs {
  colorCode: number
  count: string
  link: string
  title: string
}
interface Props {
  filter: any
  key: number
  kpi: KPIs
  sectionCode: number
  setKpiName: any
  updateKpiFilter: (e) => void
}
//SmallKPI AKA SUBMITTED or REOPENED
const SmallKPI = ({ filter, key, kpi, sectionCode, setKpiName, updateKpiFilter }: Props) => {
  const { inquiryCount } = useInquiryCount({
    ...filter,
    activeFilter: filter?.tabTable === 'ACTIVE' ? true : null, // The intention of the comparison is to make unAssignedCount impossible to return a number > 0 since an inquiry can't be both active and unassigned at the same time.
    assignedToMe: undefined,
    assignedToOther: undefined,
    customerActionRequiredFilter: null,
    isResponsePending: undefined,
    isResponseRequired: undefined,
    needToWorkFilter:null,
    pendingActionOutsideFilter: null,
    sectionCodeKPIFilter: sectionCode,
    statusCodeFilter: kpi.title,
    unassignedFilter: true,
  })
  const getExtraCount = (section, sectionCode) => {
    const { sectionCodeFilter } = filter
    const isSectionCodeIncluded =
      sectionCodeFilter === -1 ||
      (Array.isArray(sectionCodeFilter) && sectionCodeFilter.includes(sectionCode)) ||
      sectionCodeFilter === sectionCode

    return isSectionCodeIncluded ? twoDigits(section[0]?.InquiryGUID_count || 0) : '00'
  }
  const onClick = () => {
    setKpiName(kpi.title)
    updateKpiFilter({
      activeFilter: null,
      assignedToMe: undefined,
      assignedToOther: undefined,
      customerActionRequiredFilter: null,
      pendingActionOutsideFilter: null,
      sectionCodeKPIFilter: sectionCode,
      statusCodeFilter: kpi.title,
      unassignedFilter: true,
    })
  }
  return (
    <div className='col col-md-6 align-items-stretch d-flex mt-1' key={key}>
      <div className='bordered2 border-radius w-100 p-1'>
        <a
          aria-live='polite'
          className=' font-12 kpiborder border-radius kpi-before align-items-center p-relative text-decoration-none d-flex flex-column w-100 lh-1'
          onClick={onClick}
          status-kpis={kpi.colorCode}
          tabIndex={0}
          title={kpi.title}
        >
          <span className='font-11 poppins-bold pb-1'>
            {defaultToEmptyString(getExtraCount(inquiryCount, sectionCode))}
          </span>
          <span className='font-10 px-2 montserratsemibold text-nowrap text-uppercase'>
            {defaultToEmptyString(kpi.title)}
          </span>
        </a>
      </div>
    </div>
  )
}

export default SmallKPI
